/* eslint-disable */
import React from "react";
import { Field } from 'formik';
import ErrorMessage from "../ErrorMessage"
import Radio from "../../../../components/@vuexy/radio/RadioVuexy"


const RadioInput = (props) => {
    const { 
      field,
      onClick,
      externalLabel,
      options,
      defaultChecked,
      disabled,
      color,
      size, 
      customClass,
    } = props;
    return (
      options && options.map((option) => {
        return(
        <div className="d-inline-block mr-1" key={`${externalLabel}_${option.label}_${field.value}`}>
        <Radio
        {...field}
        label={option.label}
        id={`${externalLabel}_${option.label}_${field.value}`}
        value={option.value}
        className={customClass}
        size={size}
        checked={option.value === field.value || defaultChecked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        color={color}
        onClick={onClick}
        />
        </div>
        )
    })
       )
    }

const RadioButton = (props) => {
    const {
      onClick,
      validate,
      options,
      errorLabel,
      externalLabel,
      name,
      size, // sm, lg
      defaultChecked,
      disabled,
      customClass,
      color, // primary, success, danger, info, warning
    } = props;
    return (
      <div className="d-flex">
        <Field
    component={RadioInput}
    validate={validate}
    errorLabel={errorLabel}
    externalLabel={externalLabel}
    onClick={onClick}
    name={name}
    options={options}
    customClass={customClass}
    color={color}
    size={size}
    disabled={disabled}
    defaultChecked={defaultChecked}
        />
    <ErrorMessage name={name} className="field-error text-danger" />
      </div>
    );
  };
  
  export default RadioButton;